import { Action } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector as useReduxSelector } from "react-redux"
import thunk, { ThunkAction } from "redux-thunk"

import { RootState, staticReducers } from "@store/root-reducer"
import { configureAppStore } from "@eventdex/bootstrap/src/store/storeSetup"

const store = configureAppStore({}, staticReducers, undefined, [thunk])

export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>

export default store
